export const SET_TERMINALS = 'SET_TERMINAL_GLOAL';
export const GET_USER = 'GET_USER_GLOBAL';
